import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { clearLocalStore } from "helpers/localStoreSrv";
import i18n from "i18next";
import { handleErrorNavigation } from "pages/ErrorPage/ErrorHandler";
import { LANGUAGES } from "./../../constants/supported_lang";
import { useSurveySrv } from "pages/Survey/useSurveySrv";
import whitelabelConfig from "@whitelabel-config";

const MemberPortalThankYou = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const renderHtml = location.state && location.state.renderHtml;
  const isAnyAnswered = location.state.renderHtml;
  const authState = useSelector((state: any) => state.portal.authSession);
  console.log("renderHtml", location.state);
  const navigate = useNavigate();
  const [thankyouText, setThankyouText] = useState("");
  const uiState = useSelector((state: any) => state.portal.uiState);
  const { getLanguageTranslations } = useSurveySrv();
  const { rawSurveyData } = location.state;
  const getIdByName = (id: any) => {
    const language = LANGUAGES.find((lang) => lang.id === id);
    return language?.code || null;
  };
  const memberLanguage = useSelector(
    (state: any) => state.portal.uiState.Language
  );
  console.log("isAnyAnswered", isAnyAnswered);
  const preferredLanguageForSurvey = isAnyAnswered
    ? getIdByName(rawSurveyData.PreferredLanguage)
    : memberLanguage;
  // const preferredLanguageForSurvey =
  //   localStorage.getItem("preferredLanguageForSurvey") ?? "en";
  const [currentLanguage, setCurrentLanguage] = useState(
    preferredLanguageForSurvey
  );
  console.log("preferredLanguage+++++", preferredLanguageForSurvey);

  const [isRightAlign, setIsRightAlign] = useState(false);

  const updateConfirmationsByLang = (
    confirmationText: any,
    langCode: any,
    langData: any
  ) => {
    console.log("langCode", confirmationText);
    const updatedLangData =
      langData.filter((item: any) => item.LanguageCode === langCode) || [];
    const match = updatedLangData.find(
      (item: any) => item.TextCode === confirmationText
    );
    return match ? match.TextValue : confirmationText;
  };

  useEffect(() => {
    console.log("uiState.Language", uiState);
    i18n.changeLanguage(uiState.Language);
  }, []);

  const getIdByCode = (code: string) => {
    const language = LANGUAGES.find((lang) => lang.code === code);
    return language?.id || null;
  };
  useEffect(() => {
    try {
      if (
        whitelabelConfig.uiSettings.rightAlignedLanguage.includes(
          preferredLanguageForSurvey
        ) === true
      ) {
        setIsRightAlign(true);
      } else {
        setIsRightAlign(false);
      }
    } catch (e) {
      console.log("Error", e);
      handleErrorNavigation(e, navigate, t);
    }
  }, [isRightAlign, currentLanguage]);

  useEffect(() => {
    const fetchSurveyData = async () => {
      try {
        const languageData = await getLanguageTranslations(
          rawSurveyData.TranslationGroupID
        );
        console.log("languageData", languageData);
        setCurrentLanguage(preferredLanguageForSurvey);
        const languageCode = getIdByCode(preferredLanguageForSurvey);
        console.log("languageCode", languageCode);
        const translatedText = updateConfirmationsByLang(
          renderHtml,
          languageCode,
          languageData.data
        );
        console.log("translatedText123", translatedText);
        setThankyouText(translatedText);
      } catch (error) {
        handleErrorNavigation(error, navigate, t);
        console.error(
          "Error fetching survey data or TranslationGroupID",
          error
        );
      } finally {
        //setIsLoading(false);
      }
    };

    if (authState?.is_authenticated) {
      fetchSurveyData();
    } else {
      clearLocalStore();
      handleErrorNavigation(new Error("Unauthorized"), navigate, t);
    }
  }, [authState, navigate, t, currentLanguage]);

  useEffect(() => {
    if (!authState.is_authenticated) {
      const navParams = {
        state: {
          errorCode: "401",
          errorTitle: t("LANDING.UNAUTHORIZED_DEFAULT"),
          errorDescription: "",
        },
      };

      console.log(navParams);
      clearLocalStore();
      navigate("/error", navParams);
    }
  }, []);
  return (
    <div>
      <div
        style={{ textAlign: isRightAlign ? "right" : "" }}
        dangerouslySetInnerHTML={{ __html: thankyouText }}
      />
    </div>
  );
};

export default MemberPortalThankYou;
